import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import axios from 'axios';
import _get from 'lodash/get';
import { randomHex } from './strings';
import { getSiteKey } from '../components/RecaptchaProvider/RecaptchaProvider.utils';
// TODO: https://app.shortcut.com/fisherman/story/5606/add-uuid-as-a-dependency-of-fast-components-package

export var pluralBusinessTypes = ['restaurants', 'merchants'];
export function getErrorMessage(e) {
  var defaultMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'An error occurred';
  return _get(e, 'response.status') >= 500 ? defaultMessage : _get(e, 'response.data.message', '') || _get(e, 'response.data.detail', '') || _get(e, 'response.statusText', '') || defaultMessage;
}
export function getServerURL() {
  // Returns the backend server URL, always with a slash at the end
  var url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL || '';
  if (!url.endsWith('/')) {
    url += '/';
  }
  return url;
}
function createRecaptchaParams(token) {
  return {
    'recaptcha-token': token,
    'recaptcha-site-key': getSiteKey()
  };
}
export function getBusinessTypePath() {
  var businessType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!businessType) {
    return 'restaurants';
  }
  if (pluralBusinessTypes.includes(businessType)) {
    return businessType;
  }
  return "".concat(businessType, "s");
}
export function sendContactFormEmail(_x) {
  return _sendContactFormEmail.apply(this, arguments);
}
function _sendContactFormEmail() {
  _sendContactFormEmail = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var businessType, businessId, locationId, name, email, emailSubject, message, contactOptIn, recaptchaToken, destinationEmail, destinationEmails, url, fullUrl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          businessType = _ref.businessType, businessId = _ref.businessId, locationId = _ref.locationId, name = _ref.name, email = _ref.email, emailSubject = _ref.emailSubject, message = _ref.message, contactOptIn = _ref.contactOptIn, recaptchaToken = _ref.recaptchaToken, destinationEmail = _ref.destinationEmail, destinationEmails = _ref.destinationEmails;
          url = getServerURL();
          fullUrl = "".concat(url, "businesses/").concat(getBusinessTypePath(businessType), "/").concat(businessId, "/locations/").concat(locationId, "/email/");
          return _context.abrupt("return", axios.post(fullUrl, _objectSpread({
            contact_name: name,
            contact_email: email,
            contact_message: message,
            contact_opt_in: contactOptIn,
            email_subject: emailSubject,
            destination_email: destinationEmail,
            destination_emails: destinationEmails
          }, createRecaptchaParams(recaptchaToken))));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _sendContactFormEmail.apply(this, arguments);
}
export function sendDynamicFormEmail(_x2) {
  return _sendDynamicFormEmail.apply(this, arguments);
}
function _sendDynamicFormEmail() {
  _sendDynamicFormEmail = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var businessInfoId, websiteId, locationId, recaptchaToken, componentConfigurationId, formData, url, fullUrl;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          businessInfoId = _ref2.businessInfoId, websiteId = _ref2.websiteId, locationId = _ref2.locationId, recaptchaToken = _ref2.recaptchaToken, componentConfigurationId = _ref2.componentConfigurationId, formData = _ref2.formData;
          url = getServerURL();
          fullUrl = "".concat(url, "events/website/");
          return _context2.abrupt("return", axios.post(fullUrl, _objectSpread({
            business_info: businessInfoId,
            website: websiteId,
            location: locationId,
            component_configuration: componentConfigurationId,
            event_data: {
              fieldValues: formData
            }
          }, createRecaptchaParams(recaptchaToken))));
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _sendDynamicFormEmail.apply(this, arguments);
}
export function searchDomains(potentialDomain) {
  var headers = {
    'x-api-key': process.env.X_API_KEY || process.env.STORYBOOK_X_API_KEY
  };
  var url = getServerURL();
  return axios.get("".concat(url, "domains/search/details/?domain=").concat(potentialDomain), {
    headers: headers
  });
}
export function searchPlace(_x3) {
  return _searchPlace.apply(this, arguments);
}
function _searchPlace() {
  _searchPlace = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(value) {
    var types,
      params,
      headers,
      url,
      _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          types = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 'address';
          params = {
            input: value,
            session_token: randomHex(32),
            types: types
          };
          headers = {
            'x-api-key': process.env.X_API_KEY || process.env.STORYBOOK_X_API_KEY
          };
          url = getServerURL();
          return _context3.abrupt("return", axios.get("".concat(url, "businesses/search/autocomplete/"), {
            headers: headers,
            params: params
          }));
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _searchPlace.apply(this, arguments);
}
export function placeDetails(_x4) {
  return _placeDetails.apply(this, arguments);
}

/* Order */
function _placeDetails() {
  _placeDetails = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(placeId) {
    var params, headers, url;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          params = {
            place_id: placeId,
            session_token: randomHex(32)
          };
          headers = {
            'x-api-key': process.env.X_API_KEY || process.env.STORYBOOK_X_API_KEY
          };
          url = getServerURL();
          return _context4.abrupt("return", axios.get("".concat(url, "businesses/search/place/details/"), {
            headers: headers,
            params: params
          }));
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _placeDetails.apply(this, arguments);
}
function createOrderOptions(sessionToken) {
  return {
    headers: {
      Authorization: "Bearer ".concat(sessionToken)
    }
  };
}
export function getOrder(_x5, _x6) {
  return _getOrder.apply(this, arguments);
}
function _getOrder() {
  _getOrder = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(orderUuid, sessionToken) {
    var options, serverUrl, _yield$axios$get, order;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          options = createOrderOptions(sessionToken);
          serverUrl = getServerURL();
          _context5.next = 4;
          return axios.get("".concat(serverUrl, "orders/").concat(orderUuid, "/"), options);
        case 4:
          _yield$axios$get = _context5.sent;
          order = _yield$axios$get.data;
          return _context5.abrupt("return", order);
        case 7:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _getOrder.apply(this, arguments);
}
export function createOrder(_x7) {
  return _createOrder.apply(this, arguments);
}
function _createOrder() {
  _createOrder = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(productUuid) {
    var locationUuid,
      recaptchaToken,
      lineItems,
      options,
      payload,
      serverUrl,
      _yield$axios$post,
      order,
      _args6 = arguments;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          locationUuid = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : '';
          recaptchaToken = _args6.length > 2 ? _args6[2] : undefined;
          lineItems = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : [];
          options = createOrderOptions();
          payload = _objectSpread({
            merchant_product: productUuid,
            merchant_location: locationUuid,
            line_items: lineItems
          }, createRecaptchaParams(recaptchaToken));
          serverUrl = getServerURL();
          _context6.next = 8;
          return axios.post("".concat(serverUrl, "orders/"), payload, options);
        case 8:
          _yield$axios$post = _context6.sent;
          order = _yield$axios$post.data;
          return _context6.abrupt("return", order);
        case 11:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _createOrder.apply(this, arguments);
}
export function updateOrderCustomer(_x8) {
  return _updateOrderCustomer.apply(this, arguments);
}
function _updateOrderCustomer() {
  _updateOrderCustomer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(orderUuid) {
    var customer,
      recaptchaToken,
      sessionToken,
      firstName,
      lastName,
      email,
      phoneNumber,
      options,
      payload,
      serverUrl,
      _yield$axios$put,
      order,
      _args7 = arguments;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          customer = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
          recaptchaToken = _args7.length > 2 ? _args7[2] : undefined;
          sessionToken = _args7.length > 3 ? _args7[3] : undefined;
          firstName = customer.firstName, lastName = customer.lastName, email = customer.email, phoneNumber = customer.phoneNumber;
          options = createOrderOptions(sessionToken);
          payload = _objectSpread({
            first_name: firstName,
            last_name: lastName,
            email: email,
            phone: phoneNumber
          }, createRecaptchaParams(recaptchaToken));
          serverUrl = getServerURL();
          _context7.next = 9;
          return axios.put("".concat(serverUrl, "orders/").concat(orderUuid, "/customers/"), payload, options);
        case 9:
          _yield$axios$put = _context7.sent;
          order = _yield$axios$put.data;
          return _context7.abrupt("return", order);
        case 12:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _updateOrderCustomer.apply(this, arguments);
}
export function updateOrderFulfillmentRecipient(_x9) {
  return _updateOrderFulfillmentRecipient.apply(this, arguments);
}
function _updateOrderFulfillmentRecipient() {
  _updateOrderFulfillmentRecipient = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(orderUuid) {
    var fulfillment,
      recaptchaToken,
      sessionToken,
      firstName,
      lastName,
      country,
      city,
      line1,
      line2,
      postalCode,
      state,
      options,
      payload,
      serverUrl,
      _yield$axios$put2,
      order,
      _args8 = arguments;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          fulfillment = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {};
          recaptchaToken = _args8.length > 2 ? _args8[2] : undefined;
          sessionToken = _args8.length > 3 ? _args8[3] : undefined;
          firstName = fulfillment.firstName, lastName = fulfillment.lastName, country = fulfillment.country, city = fulfillment.city, line1 = fulfillment.line1, line2 = fulfillment.line2, postalCode = fulfillment.postalCode, state = fulfillment.state;
          options = createOrderOptions(sessionToken);
          payload = _objectSpread({
            first_name: firstName,
            last_name: lastName,
            street_address: line1,
            extended_address: line2,
            locality: city,
            administrative_area_level_1: state,
            postal_code: postalCode,
            country: country
          }, createRecaptchaParams(recaptchaToken));
          serverUrl = getServerURL();
          _context8.next = 9;
          return axios.put("".concat(serverUrl, "orders/").concat(orderUuid, "/recipient/"), payload, options);
        case 9:
          _yield$axios$put2 = _context8.sent;
          order = _yield$axios$put2.data;
          return _context8.abrupt("return", order);
        case 12:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _updateOrderFulfillmentRecipient.apply(this, arguments);
}
export function updateOrderFulfillment(_x10) {
  return _updateOrderFulfillment.apply(this, arguments);
}
function _updateOrderFulfillment() {
  _updateOrderFulfillment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(orderUuid) {
    var fulfillmentData,
      recaptchaToken,
      sessionToken,
      method,
      options,
      payload,
      serverUrl,
      _yield$axios$put3,
      order,
      _args9 = arguments;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          fulfillmentData = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {};
          recaptchaToken = _args9.length > 2 ? _args9[2] : undefined;
          sessionToken = _args9.length > 3 ? _args9[3] : undefined;
          method = fulfillmentData.method;
          options = createOrderOptions(sessionToken);
          payload = _objectSpread({
            method: method
          }, createRecaptchaParams(recaptchaToken));
          serverUrl = getServerURL();
          _context9.next = 9;
          return axios.put("".concat(serverUrl, "orders/").concat(orderUuid, "/fulfillments/"), payload, options);
        case 9:
          _yield$axios$put3 = _context9.sent;
          order = _yield$axios$put3.data;
          return _context9.abrupt("return", order);
        case 12:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _updateOrderFulfillment.apply(this, arguments);
}
export function updateOrderAttributes(_x11) {
  return _updateOrderAttributes.apply(this, arguments);
}
function _updateOrderAttributes() {
  _updateOrderAttributes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(orderUuid) {
    var attributes,
      recaptchaToken,
      sessionToken,
      tipPercentage,
      tip,
      specialInstructions,
      options,
      payload,
      serverUrl,
      _yield$axios$put4,
      order,
      _args10 = arguments;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          attributes = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : {};
          recaptchaToken = _args10.length > 2 ? _args10[2] : undefined;
          sessionToken = _args10.length > 3 ? _args10[3] : undefined;
          tipPercentage = attributes.tipPercentage, tip = attributes.tip, specialInstructions = attributes.specialInstructions;
          options = createOrderOptions(sessionToken);
          payload = {
            tip_percentage: 0
          };
          if (tip) {
            payload = {
              tip: tip
            };
          } else if (tipPercentage) {
            payload = {
              tip_percentage: tipPercentage
            };
          }
          payload = _objectSpread(_objectSpread({}, payload), createRecaptchaParams(recaptchaToken));
          if (specialInstructions || (specialInstructions === null || specialInstructions === void 0 ? void 0 : specialInstructions.trim()) === '') {
            payload = _objectSpread(_objectSpread({}, payload), {}, {
              instructions: specialInstructions
            });
          }
          serverUrl = getServerURL();
          _context10.next = 12;
          return axios.put("".concat(serverUrl, "orders/").concat(orderUuid, "/attributes/"), payload, options);
        case 12:
          _yield$axios$put4 = _context10.sent;
          order = _yield$axios$put4.data;
          return _context10.abrupt("return", order);
        case 15:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _updateOrderAttributes.apply(this, arguments);
}
export function setOrderPaymentSource(_x12, _x13, _x14, _x15) {
  return _setOrderPaymentSource.apply(this, arguments);
}
function _setOrderPaymentSource() {
  _setOrderPaymentSource = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(orderUuid, paymentSource, recaptchaToken, sessionToken) {
    var _paymentSource$token, token, _paymentSource$provid, providerId, options, payload, serverUrl, _yield$axios$put5, order;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _paymentSource$token = paymentSource.token, token = _paymentSource$token === void 0 ? '' : _paymentSource$token, _paymentSource$provid = paymentSource.providerId, providerId = _paymentSource$provid === void 0 ? '' : _paymentSource$provid;
          options = createOrderOptions(sessionToken);
          payload = _objectSpread({
            token: token,
            provider_id: providerId,
            "default": false
          }, createRecaptchaParams(recaptchaToken));
          serverUrl = getServerURL();
          _context11.next = 6;
          return axios.put("".concat(serverUrl, "orders/").concat(orderUuid, "/payment-source/"), payload, options);
        case 6:
          _yield$axios$put5 = _context11.sent;
          order = _yield$axios$put5.data;
          return _context11.abrupt("return", order);
        case 9:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _setOrderPaymentSource.apply(this, arguments);
}
export function getOrderLineItem(_x16, _x17) {
  return _getOrderLineItem.apply(this, arguments);
}
function _getOrderLineItem() {
  _getOrderLineItem = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(lineItemId, sessionToken) {
    var serverUrl, options, _yield$axios$get2, lineItem;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          serverUrl = getServerURL();
          options = createOrderOptions(sessionToken);
          _context12.next = 4;
          return axios.get("".concat(serverUrl, "orders/items/").concat(lineItemId, "/"), options);
        case 4:
          _yield$axios$get2 = _context12.sent;
          lineItem = _yield$axios$get2.data;
          return _context12.abrupt("return", lineItem);
        case 7:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _getOrderLineItem.apply(this, arguments);
}
export function getOrderLineItemOptions(_x18, _x19) {
  return _getOrderLineItemOptions.apply(this, arguments);
}
function _getOrderLineItemOptions() {
  _getOrderLineItemOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(lineItemId, sessionToken) {
    var serverUrl, options, _yield$axios$get3, lineItem;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          serverUrl = getServerURL();
          options = createOrderOptions(sessionToken);
          _context13.next = 4;
          return axios.get("".concat(serverUrl, "orders/items/").concat(lineItemId, "/options/"), options);
        case 4:
          _yield$axios$get3 = _context13.sent;
          lineItem = _yield$axios$get3.data;
          return _context13.abrupt("return", lineItem);
        case 7:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return _getOrderLineItemOptions.apply(this, arguments);
}
export function addOrderLineItem(_x20, _x21, _x22, _x23) {
  return _addOrderLineItem.apply(this, arguments);
}
function _addOrderLineItem() {
  _addOrderLineItem = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14(orderId, item, recaptchaToken, sessionToken) {
    var serverUrl, options, payload, _yield$axios$post2, order;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          serverUrl = getServerURL();
          options = createOrderOptions(sessionToken);
          payload = _objectSpread({
            line_items: [item]
          }, createRecaptchaParams(recaptchaToken));
          _context14.next = 5;
          return axios.post("".concat(serverUrl, "orders/").concat(orderId, "/items/"), payload, options);
        case 5:
          _yield$axios$post2 = _context14.sent;
          order = _yield$axios$post2.data;
          return _context14.abrupt("return", order);
        case 8:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return _addOrderLineItem.apply(this, arguments);
}
export function updateOrderLineItem(_x24, _x25, _x26, _x27) {
  return _updateOrderLineItem.apply(this, arguments);
}
function _updateOrderLineItem() {
  _updateOrderLineItem = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15(lineItemId, lineItemData, recaptchaToken, sessionToken) {
    var serverUrl, options, payload, _yield$axios$patch, lineItem;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          serverUrl = getServerURL();
          options = createOrderOptions(sessionToken);
          payload = _objectSpread(_objectSpread({}, lineItemData), createRecaptchaParams(recaptchaToken));
          _context15.next = 5;
          return axios.patch("".concat(serverUrl, "orders/items/").concat(lineItemId, "/"), payload, options);
        case 5:
          _yield$axios$patch = _context15.sent;
          lineItem = _yield$axios$patch.data;
          return _context15.abrupt("return", lineItem);
        case 8:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return _updateOrderLineItem.apply(this, arguments);
}
export function deleteOrderLineItem(_x28, _x29) {
  return _deleteOrderLineItem.apply(this, arguments);
}
function _deleteOrderLineItem() {
  _deleteOrderLineItem = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16(lineItemId, sessionToken) {
    var serverUrl, options;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          serverUrl = getServerURL();
          options = createOrderOptions(sessionToken);
          return _context16.abrupt("return", axios["delete"]("".concat(serverUrl, "orders/items/").concat(lineItemId, "/"), options));
        case 3:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return _deleteOrderLineItem.apply(this, arguments);
}
export function acceptOrderAdjustments(_x30) {
  return _acceptOrderAdjustments.apply(this, arguments);
}

/* Checkout */
function _acceptOrderAdjustments() {
  _acceptOrderAdjustments = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17(orderUuid) {
    var adjustments,
      recaptchaToken,
      sessionToken,
      serverUrl,
      options,
      payload,
      _yield$axios$post3,
      order,
      _args17 = arguments;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          adjustments = _args17.length > 1 && _args17[1] !== undefined ? _args17[1] : [];
          recaptchaToken = _args17.length > 2 ? _args17[2] : undefined;
          sessionToken = _args17.length > 3 ? _args17[3] : undefined;
          serverUrl = getServerURL();
          options = createOrderOptions(sessionToken);
          payload = _objectSpread({
            adjustments: adjustments
          }, createRecaptchaParams(recaptchaToken));
          _context17.next = 8;
          return axios.post("".concat(serverUrl, "orders/").concat(orderUuid, "/adjustments/"), payload, options);
        case 8:
          _yield$axios$post3 = _context17.sent;
          order = _yield$axios$post3.data;
          return _context17.abrupt("return", order);
        case 11:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return _acceptOrderAdjustments.apply(this, arguments);
}
export function startCheckout(_x31, _x32, _x33) {
  return _startCheckout.apply(this, arguments);
}
function _startCheckout() {
  _startCheckout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee18(orderUuid, recaptchaToken, sessionToken) {
    var serverUrl, options, payload, _yield$axios$post4, checkout;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          serverUrl = getServerURL();
          options = createOrderOptions(sessionToken);
          payload = _objectSpread({
            order_uuid: orderUuid
          }, createRecaptchaParams(recaptchaToken));
          _context18.next = 5;
          return axios.post("".concat(serverUrl, "checkouts/"), payload, options);
        case 5:
          _yield$axios$post4 = _context18.sent;
          checkout = _yield$axios$post4.data;
          return _context18.abrupt("return", checkout);
        case 8:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return _startCheckout.apply(this, arguments);
}
export function closeCheckout(_x34, _x35, _x36) {
  return _closeCheckout.apply(this, arguments);
}
function _closeCheckout() {
  _closeCheckout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee19(checkoutUuid, recaptchaToken, sessionToken) {
    var serverUrl, options, payload, _yield$axios$post5, checkout;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          serverUrl = getServerURL();
          options = createOrderOptions(sessionToken);
          payload = _objectSpread({}, createRecaptchaParams(recaptchaToken));
          _context19.next = 5;
          return axios.post("".concat(serverUrl, "checkouts/").concat(checkoutUuid, "/close/"), payload, options);
        case 5:
          _yield$axios$post5 = _context19.sent;
          checkout = _yield$axios$post5.data;
          return _context19.abrupt("return", checkout);
        case 8:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return _closeCheckout.apply(this, arguments);
}
export function shippingAddressValidation(_x37, _x38) {
  return _shippingAddressValidation.apply(this, arguments);
}
function _shippingAddressValidation() {
  _shippingAddressValidation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee20(recaptchaToken, addressData) {
    var country, state, city, postalCode, line1, line2, merchant, fulfillmentMethod, productId, locationId, fulfillmentType, fulfillmentProvider, payload, serverUrl, _yield$axios$post6, validationResult;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          country = addressData.country, state = addressData.state, city = addressData.city, postalCode = addressData.postalCode, line1 = addressData.line1, line2 = addressData.line2, merchant = addressData.merchant, fulfillmentMethod = addressData.fulfillmentMethod;
          productId = merchant.productId, locationId = merchant.locationId;
          fulfillmentType = fulfillmentMethod.fulfillmentType, fulfillmentProvider = fulfillmentMethod.fulfillmentProvider;
          payload = _objectSpread(_objectSpread({}, createRecaptchaParams(recaptchaToken)), {}, {
            country: country,
            state: state,
            city: city,
            postal_code: postalCode,
            line1: line1,
            line2: line2,
            merchant_product: productId,
            merchant_location: locationId,
            fulfillment_type: fulfillmentType,
            fulfillment_provider: fulfillmentProvider
          });
          serverUrl = getServerURL();
          _context20.next = 7;
          return axios.post("".concat(serverUrl, "fulfillments/address-validation/"), payload);
        case 7:
          _yield$axios$post6 = _context20.sent;
          validationResult = _yield$axios$post6.data;
          return _context20.abrupt("return", validationResult);
        case 10:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return _shippingAddressValidation.apply(this, arguments);
}